const Franchise = {
    state: ({
        franchise: null,
        id: null,
        date: null,
		token: '',
    }),
    mutations: {
        SET_FRANCHISE(state, data) {
            state.franchise = data.franchise
            state.id = data.id
            state.date = data.date
			state.token = data.token
        },
        CLEAR_FRANCHISE(state) {
            state.franchise = ''
            state.id = 0
            state.date = null
        },
        SET_FRANCHISE_DATE(state, date) {
            state.date = date
        }
    },
    actions: {
        _SET_FRANCHISE: function(context, data){
            context.commit('SET_FRANCHISE', data)
            localStorage.setItem('gestor-food-franchise', JSON.stringify(data))
        },
        _CLEAR_FRANCHISE: function(context) {
            context.commit('CLEAR_FRANCHISE')
        },
        _SET_FRANCHISE_DATE: function(context, date) {
            context.commit('SET_FRANCHISE_DATE', date)
        }
    },
    getters: {
        franchiseName: state => state.franchise,
        franchiseId: state => state.id,
        franchiseDate: state => state.date,
		franchiseToken: state => state.token,
    }
}

export default Franchise